// L'assistant IA (bibliothèque, catalogue de modèles) n'est téléchargé qu'à sa première
// utilisation : le reste de la messagerie reste aussi léger qu'avant.
import type { ComponentProps } from "preact";
import { useEffect, useState } from "preact/hooks";

type Panel = typeof import("./AiPanel");
type Settings = typeof import("./AiSettings");
type Writer = typeof import("./AiWriter");
type Inbox = typeof import("./InboxAi");
let panel: Promise<Panel> | null = null;
let settings: Promise<Settings> | null = null;
let writer: Promise<Writer> | null = null;
let inbox: Promise<Inbox> | null = null;

function useModule<T>(load: () => Promise<T>): T | null {
  const [mod, setMod] = useState<T | null>(null);
  useEffect(() => { load().then(setMod); }, []);
  return mod;
}

export function AiPanelLazy(props: ComponentProps<Panel["AiPanel"]>) {
  const mod = useModule(() => (panel ??= import("./AiPanel")));
  return mod ? <mod.AiPanel {...props} /> : <section class="reader"><div class="placeholder">Chargement…</div></section>;
}

export function AiSettingsLazy(props: ComponentProps<Settings["AiSettings"]>) {
  const mod = useModule(() => (settings ??= import("./AiSettings")));
  return mod ? <mod.AiSettings {...props} /> : <h2>Intelligence artificielle</h2>;
}

export function AiWriterLazy(props: ComponentProps<Writer["AiWriter"]>) {
  const mod = useModule(() => (writer ??= import("./AiWriter")));
  return mod ? <mod.AiWriter {...props} /> : <p class="compose-ai" role="status">Chargement de l'aide IA…</p>;
}

export function InboxAiLazy(props: ComponentProps<Inbox["InboxAi"]>) {
  const mod = useModule(() => (inbox ??= import("./InboxAi")));
  return mod ? <mod.InboxAi {...props} /> : <div class="inbox-ai-loading" role="status">Chargement du résumé IA…</div>;
}
